module.exports = __webpack_public_path__ + "static/media/CreateTransaction.26782306.png";